export default __webpack_public_path__ + "static/media/new-exit-icon.b1813dcb.svg";